module.exports = __webpack_public_path__ + "media/images/plans/e-photo_location/e-photo_location-1-b98d1f97e0012b917c24ef8366f52228.png";